import React, { FC } from 'react';
import { NavigationProps } from '@interfaces/navigation';
import { DefaultItemsList } from '@v2/pages/machines/common/components/ItemsList/DefaultItemsList';
import { Text } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';

interface MaintenanceProps extends NavigationProps {}

const Maintenance: FC<MaintenanceProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <DefaultItemsList {...props} data={props.machineStatistics.data} machinesLoaded={props.machineStatistics.loaded} />}
    >
      <Text>Maintenance</Text>
    </MachinesProvider>
  );
};

export { Maintenance };
